import api from "./api";

// 题库历史导入记录
export const getQHistory = params => {
  return api('get', `/v1/management/QuestionBank/history?difficulty=${params}`);
};

// 导入题库
export const putQuestions = params => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    }
  }
  return api("put", `/v1/management/QuestionBank/upload`, params, config);
};
